// extracted by mini-css-extract-plugin
export default {"heading":"RepayDetailsHeader_heading__nA1eL","grid":"RepayDetailsHeader_grid__ssJyZ"};